/* eslint-disable max-len */
/* eslint-disable no-lonely-if */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prettier/prettier */
/* eslint-disable no-undef */
/* eslint-disable indent */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-curly-newline */
/* eslint-disable implicit-arrow-linebreak */
import React, { useState, useCallback, useEffect } from 'react';
import { useParams, Link, useHistory } from 'react-router-dom';
import { HiDownload } from 'react-icons/hi';
import { MdCreditCard, MdBlock } from 'react-icons/md';
import { AiOutlineArrowLeft } from 'react-icons/ai';
import Button from '../../components/Button';
import TicketService from '../../services/ticket';
import { formatPrice } from '../../utils/currencyFormater';
import GenerateReportModal from './components/GenerateReportModal';
import LoaderModal from '../../components/LoaderModal';
import Modal from '../../components/Modal';
import ModalBlock from './components/ModalBlock';
import { TicketCard } from '../../interfaces/ticket';
import DownLoadFile from '../../utils/DownLoadFile';
import Loader from '../../components/Loader';
import { useToast } from '../../hooks/toast';
import ConverArrayBufferToData from '../../utils/ConverArrayBufferToData';
import {
  Row,
  Column,
  IconContainer,
} from '../../styles/components';

import {
  Container,
  Title,
  ButtonsContainer,
  SubTitle,
  Card,
  DataContainer,
  StatusRow,
  ButtonBlock,
  ModalContent,
  LinkModal,
  FormWrapper,
} from './styles';
import AuthService from '../../services/auth';
import { ButtonReCaptcha } from '../../components/ButtonReCaptcha';
import GenerateReportModalAsync from './components/GenerateReportModalAsync';

interface DetailParams {
  CrtCodIdentifExt: string;
}

const CardsDetail: React.FC = () => {
  const { CrtCodIdentifExt } = useParams<DetailParams>();
  const authService = { AuthService: new AuthService() };
  const services = { TicketService: new TicketService() };
  const { addToast } = useToast();
  const [loader, setLoader] = useState<boolean>(true);
  const [loadingModal, setLoadingModal] = useState<boolean>(false);
  const [showReportModal, setShowReportModal] = useState<boolean>(false);
  const [showReportModalAsync, setShowReportModalAsync] = useState<boolean>(false);
  const [showModalBlock, setShowModalBlock] = useState<boolean>(false);
  const [cardsDetail, setCardsDetail] = useState<TicketCard>({} as TicketCard);
  const [reportType, setReportType] = useState<string>('');
  const [titular, setTitular] = useState<any>();
  const { push } = useHistory();
  const [modalRelatorio, setModalRelatorio] = useState(false);

  const getTitular = useCallback(async () => {
    try {
      setLoader(true);
      const response = await authService.AuthService.getTitular();
      await setTitular(response.data.DadosDoTitular);
      setLoader(false);
    } catch (err) {
      setLoader(false);
      console.error(err);
    }
  }, []);

  const getCards = useCallback(async () => {
    setLoader(true);
    const response = await services.TicketService.getCardsDetail(
      { filters: [{ ticket_vt_code: CrtCodIdentifExt }] },
      CrtCodIdentifExt,
    );
    setCardsDetail(response.data.DadosDoCartao);
    setLoader(false);
  }, [cardsDetail]);

  useEffect(() => {
    getTitular();
    getCards();
  }, []);

  const getStatusText = useCallback((status: any) => {
    const statusOptions: any = {
      A: 'ATIVO',
      I: 'INATIVO',
      B: 'BLOQUEADO',
      D: 'DEVOLVIDO',
    };
    return statusOptions[status];
  }, []);

  const handleReportBalance = useCallback(
    async (type: string, cardNumber: string) => {
      const reportFilters = {
        filters: [{ 'file-type': type }, { 'card-number': cardNumber }],
      };

      try {
        setLoadingModal(true);
        const response = await services.TicketService.getTicketReportBalance(
          reportFilters,
          type,
        );
        DownLoadFile(response.data, `saldo.${type === 'C' ? 'csv' : 'pdf'}`);
        setLoadingModal(false);
      } catch (err: any) {
        setLoadingModal(false);
        const { ...error } = err;
        const errorResponse: any = ConverArrayBufferToData(error.response.data);
        if (errorResponse.message) {
          addToast({
            type: 'error',
            title: `${errorResponse.message}`,
            description: `${errorResponse.message}`,
          });
        }
        if (errorResponse.Summary) {
          addToast({
            type: 'error',
            title: `${errorResponse.Summary.ErrorCollection.SystemFailureErros[0].ErrorMessage}`,
            description: `${errorResponse.Summary.ErrorCollection.SystemFailureErros[0].InternalErrorMessage}`,
          });
        }
        if (error.response.data.Summary) {
          addToast({
            type: 'error',
            title: `${error.response.data.Summary.ErrorCollection.SystemFailureErros[0].ErrorMessage}`,
            description: `${error.response.data.Summary.ErrorCollection.SystemFailureErros[0].InternalErrorMessage}`,
          });
        }
      }
    },
    [],
  );

  // const RelatorioAgendados = useCallback(
  //   async (type: string, cardNumber: string) => {
  //     const reportFilters = {
  //       filters: [{ 'file-type': type }, { 'card-number': cardNumber }],
  //     };

  //     try {
  //       const response = await services.TicketService.getTicketReportBalance(
  //         reportFilters,
  //         type,
  //       );
  //     } catch (err: any) {
  //       const { ...error } = err;
  //       const errorResponse: any = ConverArrayBufferToData(error.response.data);
  //       if (errorResponse.message) {
  //         addToast({
  //           type: 'error',
  //           title: `${errorResponse.message}`,
  //           description: `${errorResponse.message}`,
  //         });
  //       }
  //       if (errorResponse.Summary) {
  //         addToast({
  //           type: 'error',
  //           title: `${errorResponse.Summary.ErrorCollection.SystemFailureErros[0].ErrorMessage}`,
  //           description: `${errorResponse.Summary.ErrorCollection.SystemFailureErros[0].InternalErrorMessage}`,
  //         });
  //       }
  //       if (error.response.data.Summary) {
  //         addToast({
  //           type: 'error',
  //           title: `${error.response.data.Summary.ErrorCollection.SystemFailureErros[0].ErrorMessage}`,
  //           description: `${error.response.data.Summary.ErrorCollection.SystemFailureErros[0].InternalErrorMessage}`,
  //         });
  //       }
  //     }
  //   },
  //   [],
  // );

  const handleReportExtract = useCallback(async (data: any) => {
    const reportFilters = {
      filters: [
        { 'start-date': data.start_date },
        { 'end-date': data.end_date },
        { 'file-type': data['file-type'] },
        { 'card-number': data['card-number'] },
      ],
    };
    const type = data['file-type'] === 'C' ? 'csv' : 'pdf';
    try {
      const response = await services.TicketService.getTicketExtractRecharge(
        reportFilters,
        type,
      );
      DownLoadFile(response.data, `extrato.${type}`);
    } catch (err: any) {
      setLoadingModal(false);
      const { ...error } = err;
      if (error.response.data.Summary) {
        addToast({
          type: 'error',
          title: `${error.response.data.Summary.ErrorCollection.SystemFailureErros[0].ErrorMessage}`,
          description: `${error.response.data.Summary.ErrorCollection.SystemFailureErros[0].InternalErrorMessage}`,
        });
      } else {
        addToast({
          type: 'error',
          title: 'Não foi possivel executar o serviço',
          description: 'Não existem dados para serem impressos.',
        });
      }
    }
  }, []);

  const handleReportExtractAsync = useCallback(async (data: any) => {
    const reportFilters = {
      filters: [
        { 'start-date': data.start_date },
        { 'end-date': data.end_date },
        { 'file-type': data['file-type'] },
        { 'card-number': data['card-number'] },
      ],
    };
    const type = data['file-type'] === 'C' ? 'csv' : 'pdf';
    try {
      const response = await services.TicketService.getTicketExtractRecharge(
        reportFilters,
        type,
      );
      setModalRelatorio(true);
    } catch (err: any) {
      const { ...error } = err;
      if (error.response.data.Summary) {
        addToast({
          type: 'error',
          title: `${error.response.data.Summary.ErrorCollection.SystemFailureErros[0].ErrorMessage}`,
          description: `${error.response.data.Summary.ErrorCollection.SystemFailureErros[0].InternalErrorMessage}`,
        });
      } else {
        addToast({
          type: 'error',
          title: 'Não foi possivel executar o serviço',
          description: 'Não existem dados para serem impressos.',
        });
      }
    }
  }, []);

  function relatorio() {
    push('/agendado');
  }

  // const openModalCSV = useCallback(() => {
  //   setModalRelatorio(true);
  //   RelatorioAgendados('C', CrtCodIdentifExt);
  // }, [CrtCodIdentifExt]);

  // const openModalPDF = useCallback(() => {
  //   setModalRelatorio(true);
  //   RelatorioAgendados('P', CrtCodIdentifExt);
  // }, [CrtCodIdentifExt]);

  const handleShowGenerateModal = useCallback(async (type: string) => {
    await setReportType(type);
    setShowReportModal(true);
  }, []);

  // const handleShowGenerateModalAsync = useCallback(async (type: string) => {
  //   await setReportType(type);
  //   setShowReportModalAsync(true);
  // }, []);

  // const handleBlockCard = useCallback(async (data, nome) => {
  //   try {
  //     await services.TicketService.blockCards(data.CrtCodIdentifExt, {
  //       CodigoDoMotivoDeBloqueio: '1',
  //       DescricaoBloqueio: '',
  //     });
  //     addToast({
  //       type: 'success',
  //       title: 'Sucesso',
  //       description: 'Cartão Bloqueado!!',
  //     });
  //     goBack();
  //   } catch (err: any) {
  //     const { ...error } = err;
  //     console.error(error);
  //   }
  // }, []);

  return (
    <Container>
      {loader ? (
        <Loader />
      ) : (
        <>
          {!!Object.keys(cardsDetail).length && (
            <>
              <Row className="titleWrapper">
                <Column small="2" medium="2" large="2">
                  <IconContainer align="center">
                    <MdCreditCard />
                  </IconContainer>
                </Column>
                <Column
                  small="10"
                  medium="10"
                  large="10"
                  className="TitleContainer"
                >
                  <Title>
                    <h1 className="title">
                      Meus Cartões
                      <Link to="/cartoes">
                        <AiOutlineArrowLeft
                          size={30}
                          style={{ color: '#3F1159' }}
                        />
                      </Link>
                    </h1>
                    <h1 className="card">{CrtCodIdentifExt}</h1>
                  </Title>
                </Column>
              </Row>
              <ButtonsContainer>
                <div className="buttonsInitial">
                  {/* <ButtonReCaptcha
                    disabled={titular?.BalanceView}
                    onClick={async (data: any, cb: any) => {
                      console.log({ data });
                      await handleShowGenerateModal('C');
                      cb();
                    }}
                    modalTitle="EXTRATO CSV"
                    component={({ handle }) => (
                      <Button
                        color="purple"
                        padding="1"
                        type="button"
                        className="extrato"
                        onClick={() => handle()}
                      >
                        <HiDownload />
                        EXTRATO CSV
                      </Button>
                    )}
                  />

                  <ButtonReCaptcha
                    disabled={titular?.BalanceView}
                    onClick={async (data: any, cb: any) => {
                      console.log({ data });
                      await handleShowGenerateModal('P');
                      cb();
                    }}
                    modalTitle="EXTRATO PDF"
                    component={({ handle }) => (
                      <Button
                        color="purple"
                        padding="1"
                        type="button"
                        className="extrato"
                        onClick={() => handle()}
                      >
                        <HiDownload />
                        EXTRATO PDF
                      </Button>
                    )}
                  /> */}
                  <Button
                    color="purple"
                    padding="1"
                    type="button"
                    className="extrato"
                    onClick={async () => {
                      await handleShowGenerateModal('C');
                    }}
                  >
                    <HiDownload />
                    EXTRATO CSV
                  </Button>
                  <Button
                    color="purple"
                    padding="1"
                    type="button"
                    className="extrato"
                    onClick={async () => {
                      await handleShowGenerateModal('P');
                    }}
                  >
                    <HiDownload />
                    EXTRATO PDF
                  </Button>
                  {titular?.SelectedClient && (
                    <ButtonReCaptcha
                      disabled={titular?.BalanceView}
                      onClick={async (data: any, cb: any) => {
                        console.log({ data });
                        await handleReportBalance('C', CrtCodIdentifExt);
                        cb();
                      }}
                      modalTitle="SALDO CSV"
                      component={({ handle }) => (
                        <Button
                          color="purple"
                          padding="1"
                          type="button"
                          className="saldo"
                          onClick={() => handle()}
                        >
                          <HiDownload />
                          SALDO CSV
                        </Button>
                      )}
                    />
                  )}
                  {titular?.SelectedClient && (
                    <ButtonReCaptcha
                      disabled={titular?.BalanceView}
                      onClick={async (data: any, cb: any) => {
                        console.log({ data });
                        await handleReportBalance('P', CrtCodIdentifExt);
                        cb();
                      }}
                      modalTitle="SALDO PDF"
                      component={({ handle }) => (
                        <Button
                          color="purple"
                          padding="1"
                          type="button"
                          className="saldo"
                          onClick={() => handle()}
                        >
                          <HiDownload />
                          SALDO PDF
                        </Button>
                      )}
                    />
                  )}
                </div>
              </ButtonsContainer>
              <Row>
                <Column small="2" medium="2" large="2" />
                <Column small="12" medium="12" large="12">
                  <Card>
                    <DataContainer>
                      <Column small="12" medium="6" large="6">
                        <SubTitle>Identificador do Cartão</SubTitle>
                        <h1>{CrtCodIdentifExt}</h1>
                      </Column>
                      <Row>
                        <Column small="12" medium="6" large="6">
                          <SubTitle>Funcionário</SubTitle>
                          {cardsDetail.Funcionario.Nome && (
                            <Link
                              to={`/funcionarios/${cardsDetail.Funcionario.CodigoDoFuncionario}`}
                              style={{
                                textDecoration: 'underline',
                                textUnderlinePosition: 'under',
                                color: '#3F1159',
                              }}
                              target="blank"
                            >
                              {`${cardsDetail.Funcionario.Nome}`}
                            </Link>
                          )}
                          {!cardsDetail.Funcionario.Nome && (
                            <span style={{ color: '#3F1159' }}>
                              Nenhum funcionário cadastrado
                            </span>
                          )}
                        </Column>
                        <Column small="12" medium="6" large="6">
                          <SubTitle>Classe</SubTitle>
                          <div style={{ color: '#3F1159' }}>
                            {`${cardsDetail.ClasseCartao}`}
                          </div>
                        </Column>
                        <Column small="12" medium="6" large="6">
                          <SubTitle>Status</SubTitle>
                          {cardsDetail.Status && (
                            <StatusRow
                              status={
                                cardsDetail.Status === 'A'
                                  ? 'A'
                                  : cardsDetail.Status === 'I'
                                  ? 'I'
                                  : cardsDetail.Status === 'B'
                                  ? 'B'
                                  : cardsDetail.Status === 'D'
                                  ? 'D'
                                  : 'A'
                              }
                            >
                              {getStatusText(cardsDetail.Status)}
                            </StatusRow>
                          )}
                        </Column>
                        <Column small="12" medium="6" large="6">
                          <SubTitle>Sub-Classe</SubTitle>
                          <div style={{ color: '#3F1159' }}>
                            {`${cardsDetail.SubClasseCartao}`}
                          </div>
                        </Column>
                        {cardsDetail.DataBloqueio && (
                          <Column small="12" medium="6" large="6">
                            <SubTitle>Data do Bloqueio</SubTitle>
                            <div style={{ color: '#3F1159' }}>
                              {`${cardsDetail.DataBloqueio}`}
                            </div>
                          </Column>
                        )}
                      </Row>

                      {titular?.BalanceView && (
                        <Column small="12" medium="6" large="6">
                          <SubTitle>Saldo do Cartão</SubTitle>
                          <h2>{formatPrice(cardsDetail.Saldo)}</h2>
                        </Column>
                      )}
                      <ButtonBlock>
                        <button
                          type="button"
                          onClick={() => setShowModalBlock(true)}
                        >
                          <MdBlock size={25} />
                          <p>BLOQUEAR CARTÃO</p>
                        </button>
                      </ButtonBlock>
                    </DataContainer>
                  </Card>
                  <p className="info">
                    Simples conferência‎: as informações mostradas possuem
                    defasagem de até 24 ‎horas‎.
                  </p>
                </Column>
              </Row>
            </>
          )}
        </>
      )}
      {modalRelatorio && (
        <Modal
          handleClose={() => setModalRelatorio(false)}
          show={modalRelatorio}
          title="Agendamento de Relatório"
        >
          <ModalContent>
            <FormWrapper>
              <p>Estamos processando os dados do pedido do Relatório.</p>
              <p>
                <LinkModal onClick={relatorio}>Clique Aqui!</LinkModal>
                Para abrir o menu Relatórios Agendados e acompanhar o Pedido
                solicitado. Quando este processo for finalizado basta fazer o
                download do arquivo.
              </p>
            </FormWrapper>
          </ModalContent>
        </Modal>
      )}
      {showModalBlock && (
        <ModalBlock
          cardNumber={CrtCodIdentifExt}
          title="Bloqueio de cartão"
          text={`Tem certeza de que deseja bloquear o cartão ${CrtCodIdentifExt}? (Essa ação não pode ser desfeita.)`}
          show={showModalBlock}
          handleClose={() => setShowModalBlock(false)}
          handleSuccess={getCards}
        />
      )}
      {showReportModal && (
        <GenerateReportModal
          titular={titular}
          handleClose={() => setShowReportModal(false)}
          handleAdd={data => handleReportExtract(data)}
          show={showReportModal}
          type={reportType}
          cardNumber={CrtCodIdentifExt}
          title={`Gerar ${reportType === 'C' ? 'CSV' : 'PDF'}`}
        />
      )}
      {showReportModalAsync && (
        <GenerateReportModalAsync
          titular={titular}
          handleClose={() => setShowReportModalAsync(false)}
          handleAdd={data => handleReportExtractAsync(data)}
          show={showReportModalAsync}
          type={reportType}
          cardNumber={CrtCodIdentifExt}
          title={`Gerar ${reportType === 'C' ? 'CSV' : 'PDF'}`}
        />
      )}
      {loadingModal && (
        <LoaderModal
          title="Carregando"
          show={loadingModal}
          handleClose={() => setLoadingModal(false)}
        />
      )}
    </Container>
  );
};

export default CardsDetail;
